
import { motion } from "motion/react"

const Contact = () => {
  return (
    <div className="pt-[104px]">
      <div className="relative">
        <div className="relative sm:h-[50vh]">
          <div className="z-10 absolute inset-0 bg-black bg-opacity-40"></div>
          <img src={require('../assets/imgs/contactus.webp')} alt='hero section background' className='block w-full h-full object-cover' />
        </div>
        <div className='top-1/2 left-1/2 z-20 absolute flex flex-col m-auto px-7 w-full md:w-3/4 text-white -translate-x-1/2 -translate-y-1/2'>
          <motion.h1
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }} className='font-[PlayfairDisplay] font-semibold text-[40px] md:text-[60px] text-center uppercase'>How to contact us</motion.h1>
          <motion.p
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }} className='font-[PlayfairDisplay] font-medium text-[20px] md:text-[20px] text-center'>Call or send an email</motion.p>
        </div>
      </div>
      <div className="flex lg:flex-row flex-col items-center gap-10 shadow-lg px-4 pb-8 min-h-screen">
        {/* Map Section */}
        <motion.div
        initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
        animate={{translateX: 0}}
        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
         className="w-full h-[600px]">
          <iframe
            title="office-location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.6609893622863!2d3.5580462753740005!3d6.437567793553639!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103bf7163126d9a7%3A0xf6239b9af571e374!2sMegamound%20Estate!5e0!3m2!1sen!2sng!4v1730366398489!5m2!1sen!2sng"
            className="rounded-lg w-full h-full"
            frameBorder="0"
            allowFullScreen={true}
            aria-hidden="false"
            tabIndex={0}
          ></iframe>
        </motion.div>
        <motion.div 
        initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
        animate={{translateX: 0}}
        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="space-y-8 bg-[#f4f4f4] p-6 rounded-lg w-full max-w-4xl">
          {/* Heading */}

          {/* Contact Details Section */}
          <div className="gap-8 grid grid-cols-1 md:grid-cols-2">
            <div className="space-y-4">
              <h2 className="font-semibold text-xl">Our Office</h2>
              <p className="">Grape Flat 7, New county Apartment </p>
              <p className="">Megamound Estate Ikota, Lagos, Nigeria.</p>

              <h2 className="font-semibold text-xl">Contact Information</h2>
              <p className="">Phone: 08065084918, 09020934779</p>
              <p className="">Email: akjodem@gmail.com</p>
            </div>
          </div>

          {/* Contact Form Section */}
          <form className="space-y-4">
            <div className="gap-4 grid grid-cols-1 md:grid-cols-2">
              <input
                type="text"
                placeholder="Full Name"
                className="p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
              <input
                type="email"
                placeholder="Email"
                className="p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
              />
            </div>
            <input
              type="text"
              placeholder="Subject"
              className="p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            />
            <textarea
              placeholder="Message"
              rows={4}
              className="p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            ></textarea>
            <button
              type="submit"
              className="bg-[#8f9537] hover:bg-[#6B8E23] py-3 rounded-md w-full font-semibold text-white transition duration-200"
            >
              Send Message
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
